var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_c('div',{staticStyle:{"width":"500px","margin":"0 auto","height":"500px","line-height":"500px","text-align":"center","font-size":"30px"}},[_vm._v("欢迎访问系统！")])])])
}]

export { render, staticRenderFns }